import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { GameType } from "../Data/GameData";
import * as VoiceOver from "../Data/VoiceOver";
import { GalleryItem } from "../GameObjects/GalleryItem";
import { GalleryPaintable } from "../GameObjects/GalleryPaintable";
import { PaintableMask } from "../GameObjects/PaintableMask";
import { PaintablePinata } from "./PaintablePinata";

export class GalleryPinata extends GalleryPaintable {
    constructor(pCallback: (pItem: GalleryItem) => void) {
        super(GameType.PINATA, pCallback);

        this._homePos = new PIXI.Point(0, 50);
        this._homeScale = 0.35;
        this._presentScale = 0.675;
        this._targetState = Constants.STATE_PINATA;
        this._hoverVO = VoiceOver.PINATA_BUTTON;

        this.createVisuals();
    }

    protected createVisualDefault(): void {
        const image: PIXI.Sprite = HLF.PixiUtils.makeSprite("menu-button-pinata", Constants.SPRITESHEET_MENU);
        this._visuals.addChild(image);

        this._visuals.position.copy(this._homePos);
    }

    protected createVisualComplete(): void {
        this._paintable = new PaintablePinata(this.recentIndex, false);
        this._visuals.addChild(this._paintable);

        this._visuals.position.set(-this._size.x * 0.5 - this._paintable.width * 0.5, -100);
    }

    protected createVisualCached(): void {
        super.createVisualCached();
        this._cached!.scale.set(this._homeScale);
    }
}
